<template>
<div style="padding-top: -2px; margin-top: -2px">
    <vc-select-generic 
        ref="suser" 
        autocomplete 
        class="text" 
        itemtext="UsrFullName" 
        itemvalue="UsrID" 
        :disabled="disabled" 
        id="UsrID" 
        :value="value" 
        :return-object="returnObject" 
        @input="input($event)" 
        :config="config" 
        :label="label" 
        :full="full" 
        :autofocus="autofocus" 
        :text="text" 
        :clearable="clearable" 
        :noDefault="noDefault" 
        :outlined="outlined"
    >
    </vc-select-generic>
</div>
</template>

<script>
import _sUserService from "@/services/Security/SecUserService";
export default {
    name: "SelectUser",
    components: {},
    props: {
        autofocus: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: false,
        },
        value: null,
        text: {
            type: String,
            default: ""
        },
        label: {
            type: String,
            default: "",
        },
        returnObject: {
            type: Boolean,
            default: false,
        },
        noDefault: {
            type: Boolean,
            default: false,
        },
        full: {
            type: Boolean,
            default: false,
        },

        outlined: {
            type: Boolean,
            default: true
        },
        areID:{
            type:Number,
            default: 0
        },
        isAdviser: {
        type: Number,
        default: null
        }
    },
    watch: {
        value(value) {
            console.log("text",this.text);
            this.item = value;
        },
    },
    methods: {
        focus() {
            this.$refs.sarea.focus();
        },
        input(val) {
            this.$emit("input", val);
        },
    },
    data: () => ({
        item: 0,
        val: "",
        items: [],
        config: {},
    }),

    created() {
        console.log("text",this.text)
        this.config = {
            url: _sUserService.getUrlSearchUser(),
            title: this.label,
            params: {
                areID : this.areID,
                isAdviser: this.isAdviser
            },
        };
    },
};
</script>
